<div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title">OPÇÕES DE TABELA</h3>
    </div>
    <div class="modal-body">
      <form [formGroup]="formulario" class="forms">
        <div class="form-group" style="display: block;">
          <label for="tabela" class="label-full-width">Opções disponíveis</label>
          <select
              class="form-control"
              appShowErrorMessages
              requiredMessage="O campo tabela é obrigatório"
              formControlName="tabela"
              name="tabela">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let tabela of tabelas" value="{{ tabela.id }}">{{ tabela.descricao }}</option>
          </select>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-md-12">
          <a class="bt-back btn btn-border-orange pull-left" (click)="close()"> Fechar</a>
          <button
            type="button"
            class="bt-go btn btn-full-orange pull-right"
            [disabled]="!formulario.valid"
            (click)="save()">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
